<template>
  <div>
    <div class="modal-container" @keydown.esc="hideForm()">
      <form class="px-4 py-5 modal-content">
        <div class="d-flex justify-content-between">
          <h2 class="text-capitalize pb-5 px-2 header">create new survey</h2>
          <div class="close-btn">
            <span @click="hideForm()">
              <close-svg />
            </span>
          </div>
        </div>
        <div class="mb-5">
          <input
            ref="formInput"
            class="
              survey-title
              pb-2
              px-4
              d-flex
              align-items-center
              text-capitalize
            "
            placeholder="Survey Title"
            type="text"
            v-model="surveyName"
          />
          <small
            v-if="surveyName === ''"
            class="text-danger text-capitalize px-4"
          >
            Survey Title is required
          </small>
        </div>
        <dropdown-with-search>
          <template v-slot:subtitle>Survey Product</template>

          <template v-slot:dropdownBody>
            <v-select
              v-model="surveyProduct"
              class="w-100"
              :options="surveyProductOptions"
              placeholder="search"
              label="name"
            ></v-select>
          </template>

          <template v-if="surveyProduct === ''" v-slot:warning
            >Survey Product is required
          </template>
        </dropdown-with-search>

        <dropdown-with-search>
          <template v-slot:subtitle> Survey Group </template>

          <template v-slot:dropdownBody>
            <v-select
              v-model="surveyGroup"
              class="w-100"
              :options="surveyGroupOptions"
              label="name"
              placeholder="search"
            ></v-select>
          </template>

          <template v-if="surveyGroup === ''" v-slot:warning>
            Survey Group is required
          </template>
        </dropdown-with-search>

        <div class="text-center">
          <button class="border-0 btn-start" @click.prevent="letsGo()">
            <a class="text-capitalize py-3 px-5 d-block">let's go!</a>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DropdownWithSearch from "@/components/ui/dropdown-with-search";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNewSurveyForm",
  components: {
    DropdownWithSearch,
  },
  data() {
    return {
      surveyProduct: undefined,
      surveyGroup: undefined,
      surveyName: undefined,
    };
  },
  computed: {
    ...mapGetters("surveyJourney", {
      surveyProductOptions: "productsDataset",
      surveyGroupOptions: "customerGroupsDataset",
    }),

    formValid() {
      return this.surveyProduct && this.surveyGroup && this.surveyName;
    },
  },
  methods: {
    ...mapActions("surveyJourney", ["hideForm", "createFormValues"]),

    letsGo() {
      if (this.formValid) {
        const createFormValues = {
          surveyName: this.surveyName,
          Products: this.surveyProduct,
          CustomerGroup: this.surveyGroup,
        };
        this.createFormValues(createFormValues);
        this.$router.push({ name: "SurveyJourney" });
        this.surveyProduct = undefined;
        this.surveyGroup = undefined;
        this.surveyName = undefined;
        this.hideForm();
      } else {
        this.surveyProduct =
          this.surveyProduct === undefined ? "" : this.surveyProduct;
        this.surveyGroup =
          this.surveyGroup === undefined ? "" : this.surveyGroup;
        this.surveyName = this.surveyName === undefined ? "" : this.surveyName;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.survey-title {
  @extend %font-48_64-regular;
  @extend %background-grey_radius-36;
  outline: unset;
  color: $color-white;
  border: unset;

  &::placeholder {
    color: $color-white;
  }
}
</style>
